import React from "react";
import { IItems } from "../../@types/types";
import { getReleaseInfo } from "../../utils";
import MenuGroups from "../menu-items/MenuGroups";
import SideBarInner from "./SideBarInner";
import FeatherIcon from "feather-icons-react";

interface SubMenuItemProps {
  selectedItem: IItems;
  inputValue: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  top: number;
  handleSubMenuClose: () => void;
}

export const SubMenuItem: React.FC<SubMenuItemProps> = ({
  selectedItem,
  inputValue,
  onChange,
  top,
  handleSubMenuClose,
}) => {
  return (
    <div className='subitem-wrapper' style={{ top: `${top}px` }}>
      <small
        style={{ marginRight: "20px", opacity: 0.7 }}
        className='release-info'
      >
        v. {getReleaseInfo()}
      </small>
      <FeatherIcon
        icon='x'
        className='close-icon-sub'
        onClick={() => {
          handleSubMenuClose();
        }}
      />
      {selectedItem.menu?.search || selectedItem.menu?.quickLinks?.length ? (
        <SideBarInner
          selectedItem={selectedItem}
          inputValue={inputValue}
          onChange={onChange}
        />
      ) : null}
      {selectedItem.menu?.menuGroups || selectedItem.menu?.additionalLinks ? (
        <MenuGroups
          groups={selectedItem.menu.menuGroups}
          additionalLinks={selectedItem.menu.additionalLinks || []}
        />
      ) : null}
    </div>
  );
};
